import React, {Suspense, useState} from 'react'
import {useOnEvent} from 'react-app-events'
import DeliveryWizard from '@components/DeliveryWizard'
import useMessage from '@hooks/useMessage'
import {useTranslation} from 'next-i18next'

import AddressAndTimeLabel from './AddressAndTimeLabel'
import CartDeliverySkeleton from './Skeleton'

function InnerCartDelivery() {
  const {t} = useTranslation('website', {keyPrefix: 'delivery'})
  const showMessage = useMessage()
  const [open, setOpen] = useState<boolean>(false)

  useOnEvent('hiddenPriceProductOpened', async () => {
    showMessage(t('hiddenPriceWarning'))
    setOpen(true)
  })

  return (
    <div className="mx-2">
      <div
        className={
          'px-2 py-2 flex items-center text-sm cursor-pointer bg-gray-100 dark:bg-zinc-600 rounded-full'
        }
        onClick={() => setOpen(true)}>
        <AddressAndTimeLabel />
      </div>
      <DeliveryWizard.AsModal
        actionLocation="order-delivery"
        isOpen={open}
        onClose={() => setOpen(false)}
      />
    </div>
  )
}

export default function CartDelivery() {
  return (
    <Suspense fallback={<CartDeliverySkeleton />}>
      <InnerCartDelivery />
    </Suspense>
  )
}
